<app-header></app-header>
<app-audio-player-portal></app-audio-player-portal>
<app-notification *ngIf="SEC || STB"></app-notification>
<!-- <app-local-notification 
    (closeFinding)="getFinding($event)" 
></app-local-notification> -->
<div class="d-flex justify-content-center spinner-content" *ngIf="finding">
    <div class="py-5">
        <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
    </div>
</div>

<app-content [hidden]="!showContent"></app-content>
<!-- <app-access></app-access> -->
<app-footer  [ngClass]="{
    'footer': showContent === false }"></app-footer>